import { render } from "./DataTableContract.vue?vue&type=template&id=b440a79e"
import script from "./DataTableContract.vue?vue&type=script&lang=js"
export * from "./DataTableContract.vue?vue&type=script&lang=js"

import "./DataTableContract.vue?vue&type=style&index=0&id=b440a79e&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__